import { memo } from "react";
import Box from "@mui/material/Box";
import LinearProgress from "@mui/material/LinearProgress";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import PercentIcon from "@mui/icons-material/Percent";
import SmsIcon from "@mui/icons-material/Sms";
import TimelineIcon from "@mui/icons-material/Timeline";

import IconInfoCard from "src-next/shared/ui/cards/IconInfoCard";

import type {
  CrmMessageUsageStats,
} from "../types";

export interface CrmMessageStatisticsCardsProps {
  messageUsageStats: CrmMessageUsageStats | null;
}

const CrmMessageStatisticsCards = memo<CrmMessageStatisticsCardsProps>(
  ({ messageUsageStats }) => {
    const contracted = messageUsageStats?.totalMessagesContracted ?? 0;
    const used = messageUsageStats?.totalMessagesUsed ?? 0;
    const available = messageUsageStats?.totalMessagesAvailable ?? 0;
    const usageRate = messageUsageStats?.usageRateInPercentage ?? 0;

    return (
      <Box
        sx={{
          display: "grid",
          gap: 2,
          gridTemplateColumns: {
            xs: "1fr",
            md: "repeat(2, minmax(0, 1fr))",
            xl: "repeat(3, minmax(0, 1fr))",
          },
        }}
      >
        <IconInfoCard
          icon={<PercentIcon />}
          title="Taxa de uso da franquia"
          color="primary"
          sx={{ minHeight: 220 }}
        >
          <Stack spacing={1.25}>
            <Typography variant="h4" fontWeight={700}>
              {`${usageRate}%`}
            </Typography>
            <LinearProgress
              variant="determinate"
              value={usageRate}
              sx={{ height: 8, borderRadius: 999 }}
            />
            <Typography variant="body2" color="text.secondary">
              Usadas: {used.toLocaleString("pt-BR")} · Contratadas:{" "}
              {contracted.toLocaleString("pt-BR")}
            </Typography>
          </Stack>
        </IconInfoCard>

        <IconInfoCard
          icon={<SmsIcon />}
          title="Mensagens contratadas"
          color="secondary"
          sx={{ minHeight: 220 }}
        >
          <Stack spacing={0.75}>
            <Typography variant="h4" fontWeight={700}>
              {contracted.toLocaleString("pt-BR")}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Total de mensagens previstas no pacote atual.
            </Typography>
          </Stack>
        </IconInfoCard>

        <IconInfoCard
          icon={<TimelineIcon />}
          title="Mensagens disponíveis"
          color="success"
          sx={{ minHeight: 220 }}
        >
          <Stack spacing={0.75}>
            <Typography variant="h4" fontWeight={700}>
              {available.toLocaleString("pt-BR")}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Estimativa de saldo restante de mensagens (mock).
            </Typography>
          </Stack>
        </IconInfoCard>
      </Box>
    );
  },
);

CrmMessageStatisticsCards.displayName = "CrmMessageStatisticsCards";

export default CrmMessageStatisticsCards;

